// extracted by mini-css-extract-plugin
export default {"root":"UserWidget-root_zGjar","svg":"UserWidget-svg_tgPTQ","link":"UserWidget-link_eFr3K"};